import { createSelector } from 'reselect';
import { getSelectorRoot } from 'utils/selectors';
// import { EPersonalIdTypes } from 'newcomponents/Shared/account/Fields/PersonalIdField/personalIdField.type';

const getAppData = getSelectorRoot('appData');

export const getColCount = getAppData('colCount');
export const getRecaptchaEnabled = getAppData('recaptchaEnabled');
export const getRecaptchaVersion = getAppData('recaptchaVersion');
export const getSiteKey = getAppData('siteKey');
export const getTurnstileEnabled = getAppData('turnstileEnabled');
export const getTurnstileSiteKey = getAppData('turnstileSiteKey');
export const getTurnstileVerifyActions = getAppData('turnstileVerifyActions');
export const getRecaptchaKey = getAppData('recaptchaKey');
export const getDataConfigs = getAppData('dataConfigs');
export const getRounding = getAppData('rounding');
export const getRoundingLoading = getAppData('roundingLoading');
export const _getRegFieldData = getAppData('regFieldData');
export const getRegFieldData = createSelector([_getRegFieldData], regFields => {
  // @Todo need to remove after development
  return regFields;
  // console.log(regFields);
  //
  // const updated = regFields?.map(f => {
  //   // if (f.name === '')
  //   if (f.name === 'personal_id') {
  //     return {
  //       ...f,
  //       editForm: {
  //         ...f.editForm,
  //         checkByCountryRUT: '1',
  //         personalIdType: EPersonalIdTypes.rut
  //       }
  //     };
  //   }
  //
  //   return f;
  // });
  //
  // if (!updated) {
  //   return updated;
  // }
  //
  // const genderIndex = updated.findIndex(f => f.formType === 'gender');
  // const gender = updated[genderIndex];
  //
  // updated.splice(genderIndex, 1);
  // updated.unshift(gender);
  //
  // return updated;
});
export const getShowAdditionalInfo = getAppData('showAdditionalInfo');
export const getPersonalizedGenericSettings = getAppData(
  'personalizedGenericSettings'
);
export const getOpenedModals = getAppData('openedModals');
export const getAtoZMenuData = getAppData('atozMenuData');
export const getMenuJsonData = getAppData('menuJsonData');
export const getSectionsData = getAppData('sectionsData');
export const getAccountParams = getAppData('accountParams');
export const getPostGridHiddenParams = getAppData('postGridHiddenParams');
export const getCashoutModalOpen = getAppData('cashoutModalOpen');
export const getDepositModalOpen = getAppData('depositModalOpen');
export const getDepositStatus = getAppData('confirmedDeposit');
export const getFirebaseToken = getAppData('fireBaseToken');
export const getOneSignalSubId = getAppData('oneSignalSubId');
export const getHeaderState = getAppData('headerState');
export const getGeolocationShakeData = getAppData('geolocationShakeData');
export const getHomeworkData = getAppData('homeworkData');
export const getSportsConfigsData = getAppData('sportsConfigsData');
export const getIsPaymentsLoading = getAppData('isPaymentsLoading');
export const getCryptoCurrencies = getAppData('setCryptoCurrencies');
export const getBetShopsData = getAppData('betShops');
export const getSID = getAppData('sid');
export const getRemainingSessionDuration = getAppData(
  'remainingSessionDuration'
);
export const getFavoriteOnHeaderOpen = getAppData('favoriteOnHeaderOpen');
export const getFavoriteSelectedTab = getAppData('favoriteSelectedTab');
export const getIdinData = getAppData('idinData');
export const getLocateData = getAppData('locateData');
export const getIsDarkMode = getAppData('isDarkMode');
export const getHigherZIndex = getAppData('higherZIndex');
export const getInitSportsbookIframe = getAppData('initSportsbookIframe');
export const getForgotPasswordOpen = getAppData('forgotPasswordOpen');
export const getForgotUsernameOpen = getAppData('forgotUsernameOpen');
export const getShowToTopNav = getAppData('showToTopNav');
export const getTourSteps = getAppData('tourSteps');
export const gettourStepsInitialData = getAppData('tourStepsInitialData');
export const getTourModalVisible = getAppData('tourModalVisible');
export const getAfterSignInActions = getAppData('afterSignInActions');
export const getGeoComplyErrorPopupAvailable = getAppData(
  'geoComplyErrorPopupAvailable'
);
export const getGeoComplyErrorPopupText = getAppData('geoComplyErrorPopupText');
export const getLeftSidebarOpenCloseTrigger = getAppData(
  'leftSidebarOpenCloseTrigger'
);
export const getSportsbookConfigs = getAppData('sportsbookConfigs');
